// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__X64kB","row":"styles_row__8gNVo"};